import { render, staticRenderFns } from "./DeviceUpstreamTransferRecord.vue?vue&type=template&id=60245a36&scoped=true&"
import script from "./DeviceUpstreamTransferRecord.vue?vue&type=script&lang=js&"
export * from "./DeviceUpstreamTransferRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60245a36",
  null
  
)

export default component.exports